import { useMemo } from 'react';
import { Button } from 'semantic-ui-react';
import classNames from 'classnames';
import { getUserAllowedStatuses } from 'modules/get-user-allowed-statuses/get-user-allowed-statuses';
import Label from 'components/Label/Label';
import './status-filters.scss';

export default function StatusFilters({
  activeStatuses,
  onToggleStatus = () => {},
}) {
  const allowedStatus = useMemo(() => getUserAllowedStatuses(), []);

  return (
    <div className="status-filters">
      <Label small className="status-filters__label">
        Estado
      </Label>
      {Object.entries(allowedStatus).map(([key, value]) => (
        <Button
          className={classNames(
            'status-filters__fitler',
            `status-filters__filter--${value.className}`,
          )}
          key={key}
          toggle
          circular
          active={activeStatuses.includes(key)}
          size="mini"
          onClick={(event, data) => {
            onToggleStatus(key);
          }}
        >
          {value.text}
        </Button>
      ))}
    </div>
  );
}
